import ApiService from "./api.service";
import axios from 'axios';

// Constant
const baseUrl = 'image/'

const ImageService = {
	/**
	 * Retrieve all images from upload folder
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	retrieveUploadedImages(params) {
		return ApiService.get(baseUrl, params);
	},
	/**
	 * Delete image
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	delete(id) {
		return ApiService.delete(baseUrl + `${id}`);
	},
	/**
	 * Upload image to server directly from client side 
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	upload(params) {
		return ApiService.post(baseUrl + 'upload', params);
	},
	/**
	 * Upload image to server using specified s3 key 
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	uploadFromS3Key(params) {
		return ApiService.get(baseUrl + 'upload', params);
	},
	/**
	 * Get presigned download url   
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	getPresignedUrlPost(params) {
		return ApiService.get(baseUrl + 'upload/presign', params);
	},
	/**
	 * Upload file to url   
	 * @param {string} url 
	 * @param {BinaryData} file 
	 * @param {string} fileType 
	 * @returns {Response} response
	 */
	uploadFileToS3(url, content) {
		return axios.post(url, content)
	},
	getAllDetectedImages(params){
		return ApiService.get(baseUrl + 'detected/all', params)
	},
	// TODO: change api to get raw images
	getAllRawDetectedImages(params){
		return ApiService.get(baseUrl + 'detected/all', params)
	},
	getAllDetectedResults(params){
		return ApiService.get(baseUrl + 'detected/all/count', params)
	},
	getDetectedImageByLimit(params) { 
		return ApiService.get(baseUrl + 'detected/limit', params);
	},
	getPresignedUrl(params){
		return ApiService.get(baseUrl + 'dowload/presign', params)
	},
	/**
	 * Retrieve all image for express-trainer
	 * @param {Params} params 
	 * @returns {Response} response
	 */
	retrieveAllTrainerImages(params){
		return ApiService.get(baseUrl + 'trainer', params);
  },
	uploadTrainerImages(params) { 
		return ApiService.post(baseUrl + 'upload/train', params);
	},
	deleteTrainerImages(params) { 
		return ApiService.delete(baseUrl + 'train', params);
	},
	deleteLocalImages(params) { 
		return ApiService.delete(baseUrl + 'local_image', params);
	},
	deleteImageHistory(id) {
		return ApiService.delete(baseUrl + 'history',id);
	},
};

export default ImageService;